import { Component, HostBinding, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'copo-loading-spinner',
	templateUrl: './loading-spinner.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	standalone: true
})
export class LoadingSpinnerComponent {
	@HostBinding('class.loading-spinner-container') @Input() container = true;
}
